import { render, staticRenderFns } from "./RecommendSummary.vue?vue&type=template&id=758b2332&scoped=true"
import script from "./RecommendSummary.vue?vue&type=script&lang=js"
export * from "./RecommendSummary.vue?vue&type=script&lang=js"
import style0 from "./RecommendSummary.vue?vue&type=style&index=0&id=758b2332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758b2332",
  null
  
)

export default component.exports